<template>
     <nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
        <div class="container-fluid">
          <!-- Brand -->
          <router-link class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" :to="{ name: controller.main }">{{controller.title}}</router-link>
          <!-- User -->
          <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
              <a class="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <div class="media align-items-center">
                  <img src="@/assets/img/default.png" class="avatar avatar-sm rounded-circle d-none" alt="...">
                  <img :src="'https://ui-avatars.com/api/?background=E91E63&color=fff&name=' + user.name" class="avatar avatar-sm rounded-circle" alt="...">
                  <div class="media-body ml-2 d-none d-lg-block">
                    <span class="mb-0 text-sm  font-weight-bold">{{ user.name }}</span>
                  </div>
                </div>
              </a>
              <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
                <div class=" dropdown-header noti-title">
                  <h6 class="text-overflow m-0">¡Bienvenido!</h6>
                </div>
                <router-link :to="{ name: 'account' }" class="dropdown-item">
                  <i class="ni ni-single-02"></i>
                  <span>Mi Cuenta</span>
                </router-link>
                <a class="dropdown-item" href="javascript:void(0);"  @click="toggleModal">
                  <i class="fa fa-sync-alt"></i> <span>Sincronizar</span>
                </a>
                <router-link :to="{ name: 'account'}" class="dropdown-item d-none">
                  <i class="ni ni-settings-gear-65"></i>
                  <span>Configuración</span>
                </router-link>
                <div class="dropdown-divider"></div>
                <button @click="logout()" class="dropdown-item">
                  <i class="ni ni-user-run"></i>
                  <span>Cerrar sesión</span>
                </button>
              </div>
            </li>
          </ul>
        </div>


        <sync-modal :showSyncModal="showSyncModal" />


      </nav>
</template>

<script>
import Auth from '@/helpers/middleware';
import syncModal from '@/components/layout/_syncModal'

export default {
  components: {
    syncModal
  },
  data(){
    return{
      user: Auth.getUser(),
      showSyncModal: false
    }
  },
  props: ["controller"],
  methods:{
    logout(){
      Auth.logOut()
    },
      showModal() {
        this.showSyncModal = true;
      },
      hideModal() {
        this.showSyncModal = false;
      },
      toggleModal() {
        this.showSyncModal = !this.showSyncModal;
      }
  }
};
</script>
